<template>
  <div>
    <div
      style="width: 30px; height: 30px; position: fixed; top: 0; right: 0"
      @click="escPrint"
    ></div>
    <section class="sheet padding-10mm">
      <div class="border d-flex">
        
        <map-view :mainObj="myData" class="my-print-map"></map-view>
        <div class="map-legend-container">
          <div class="p-1">
            <p>نام فیدر:</p>
 <p><b>{{feederName.split('_').join(" ")}}</b></p>
          </div>
          <feeder-total-cal v-bind:feederId="$route.params.feederId"></feeder-total-cal>
         
        </div>
           <!-- <div id="m-feeder-name">{{ feederName }}</div>  -->
        <!-- <img alt="Vue logo" src="../assets/logo.png" /> -->
        <!-- <img alt="Vue logo" src="../assets/legend_top.PNG" /> -->
      </div>

      <!-- <img src="../assets/legend_top.PNG" width="100" height="100"> -->
    </section>
  </div>
</template>


<script>
import { ApiTls } from "../../src/app/tools/ApiTls";
import FeederTotalCal from "../components/FeederTotalCal";
import { PrintTls } from "../app/tools/PrintTls";
import MapView from "../components/MapView";

export default {
  components: { MapView ,FeederTotalCal},
  name: "Feeder",
  data() {
    return {
      feederId: 0,
      feederData: {},
      myData: {},
      feederName: "sa",
    };
  },
  mounted() {
    ApiTls.getFeederData(this.$route.params.feederId, this.setResData);
    PrintTls.makePrintable();
    document.title = this.$route.params.feederId + " - A4";
  },
  watch: {
    myData() {
      if (this.myData.feeder.length)
        this.feederName = this.myData.feeder[0]["feeder_name"];
      else this.feederName = "";
    },
  },
  methods: {
    setResData(res) {
      this.myData = res.data;
    },

    escPrint() {
      PrintTls.escPrintable();
    },
  },
};
</script>



<style >
.my-print-map {
  height: 10mm;
}
body.printable .my-map,
.my-print-map {
  min-height: 140mm !important;
  height: 190mm !important;
  width: 240mm !important;

  /* height: 100%;
    width: 50%;
    position: absolute;
    right: 10mm;
    top: 10mm; */
}
.map-legend-container{
  float: right;
  
  top: 0;
  height: 190mm !important;
  width: 35mm !important;
  /* background: #333; */
  font-family: Vazir;
  direction: rtl;
  text-align: justify;
}
</style>

<style scoped>
@page {
  size: A4 landscape;
}

#m-feeder-name {
  position: absolute;
  top: 10;
  left: 10;
  font-family: Vazir;
}
</style>